import { useEffect, useState } from "react"
import { useParams } from "react-router";
import { OrderItemRow } from ".";
import OrderAPI from "../../../lib/API/OrderAPI";
import Currencies from "../../../lib/Currencies";

const OrderStatus = {
    WAITING : 'WAITING',
    PROCESSING : 'PROCESSING',
    CANCELED : 'CANCELED',
    DELIVERED : 'DELIVERED',
}

const OrderDetails = () => {

  const { orderId } = useParams();
  const [order, setOrder] = useState();
  const [orderPaid, setOrderPaid] = useState(false);

  useEffect(() => {
    OrderAPI.GetOrder(orderId)
      .then(({ data }) => {
        setOrder(data);
        setOrderPaid(data.status == OrderStatus.PAID || data.status == OrderStatus.DELIVERED)
      })
      .catch(() => alert('An error occured, try to refresh'));
  }, [orderId])

  return (
    <div className="row">
      <div className="col-lg-8 offset-lg-2 col">
        <h5>Order details</h5>

        {order && (<>
          <table className="items">
            <thead>
              <tr>
                <td colspan="2">Product(s)</td>
                <td style={{ width : "100px" }}>Quantity</td>
                <td style={{ width : "150px" }}>Price</td>
                <td>Redeem Code</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {order.items.map((item, i) => (
                <OrderItemRow orderId={order.id} orderDelivered={order.status == OrderStatus.DELIVERED} item={item} key={i}/>
              ))}
            </tbody>
          </table>
          <div className="amoutdue">
            <p>Total <span>{order.amount.toFixed(4)} {order.token}</span></p>
          </div>
        </>)}
      </div>
    </div>
  )
}

export { OrderDetails }